import { styled } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

export const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
  '.MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette['secondary'].main,
    color: theme.palette['primary'].main,
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
}));
